export default __webpack_public_path__ + "static/media/compartilharPastaMenuNovo.f6e8d974.svg";